import useAuth from 'hooks/useAuth';
import { useMutation, useQuery } from 'react-query';
// import { NoteUpdateType } from 'types/note';
// import { ToDo } from 'types/todo';

export default function useToDo(filter?) {
  const { request, userId } = useAuth();
  const {
    data: todo,
    refetch,
    isLoading: listLoading,
    isFetching
  } = useQuery(
    `dashboard/todolist`,
    () =>
      request
        .get(`/dashboard/todolist`, {
          params: { filter: filter.date, userId }
        })
        .then((response) => response.data as any),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: !!userId
    }
  );

  const { mutateAsync: createToDo, isLoading: createLoading } = useMutation(
    '/dashboard/todolist',
    (payload: any) => request.post('/dashboard/todolist', payload).then((response) => response.data),
    { onSuccess: () => refetch() }
  );

  const { mutateAsync: updateToDo, isLoading: updateLoading } = useMutation(
    '/dashboard/todolist',
    ({ id, payload }: { id: any; payload: any }) => request.put(`/dashboard/todolist/${id}`, payload).then((response) => response.data),
    { onSuccess: () => refetch() }
  );

  const { mutateAsync: deleteToDo, isLoading: deleteingLoading } = useMutation(
    '/dashboard/todolist/todoId',
    ({ id }: { id: any }) => request.delete(`/dashboard/todolist/${id}`).then((response) => response.data),
    { onSuccess: () => refetch() }
  );

  return {
    todo,
    refetch,
    createToDo,
    updateToDo,
    deleteToDo,
    isLoading: isFetching || listLoading || createLoading || updateLoading || deleteingLoading
  };
}
